export const POS_TERMINALS = {
    COLLECTION: {
        url: '/posTerminals'
    },
    DETAILS: {
        url: '/posTerminals/:posTerminalId'
    },
    EVENT_LOGS_COLLECTION: {
        queryKey: 'getEventLogs',
        url: '/posTerminals/:posTerminalId/eventLogs'
    },
    TRANSACTIONS: {
        queryKey: 'getTransactions',
        url: '/posTerminals/:posTerminalId/transactions'
    },
    EXPORT_TRANSACTIONS: {
        url: '/posTerminals/:uuid/transactionsExport'
    },
    EXPORT_REMOTE_COLLECTIONS: {
        url: '/posTerminals/:uuid/remoteCollectionsExport'
    },
    ETHERNET_LOCATION: {
        queryKey: 'getGeolocation',
        url: '/geoLocation/:posTerminalUuid'
    },
    FETCH_CONNECTION_POINTS: {
        queryKey: 'getConnectionPoints',
        url: '/posTerminalSubscriptions/:subscriptionId/connectionPoints'
    },
    BLACKLIST_POS_TERMINAL: {
        url: '/blacklist/add/:subscriptionId'
    },
    BLACKLIST_MULTI: {
        url: '/blacklist/add'
    },
    BLACKLIST_MULTI_FILE_ACTION: {
        url: '/blacklist/addMultiple/fileAction'
    },
    UNBLACKLIST_POS_TERMINAL: {
        url: '/blacklist/remove/:subscriptionId'
    },
    IN_STOCK: {
        url: '/posTerminalSubscriptions/:subscriptionId/rewarehouse'
    },
    INFO_STATUS_POS_TERMINAL: {
        url: '/blacklist/get/:posTerminalUuid'
    }
};